<!-- <div ngbDropdown class="d-inline-block" placement="bottom-start">
    <button type="button" class="btn btn-outline-primary" id="videomenu" ngbDropdownToggle>
        <fa-icon [icon]="dots"></fa-icon>
    </button>
    <div ngbDropdownMenu aria-labelledby="dropdownBasic1" id="videomenu-dropdown">
        <a ngbDropdownItem (click)="onPin()">
            <fa-icon [icon]="pinIcon"></fa-icon>
        </a>
        <a ngbDropdownItem (click)="onMicMute()">
            <fa-icon [icon]="micMuteIcon"></fa-icon>
        </a>
        <a ngbDropdownItem (click)="onCamOff()">
            <fa-icon [icon]="camMuteIcon"></fa-icon>
        </a>
        <a ngbDropdownItem (click)="onCick()">
            <fa-icon [icon]="kickIcon"></fa-icon>
        </a>
    </div>
</div> -->

<button mat-icon-button [matMenuTriggerFor]="menu"  aria-label="Participant Menu"   yPosition="below" id="meetingMenuBtn">
    <mat-icon>more_horiz</mat-icon>
  </button>
  <mat-menu #menu="matMenu" id="meetingMenu" [overlapTrigger]="false">
    <button mat-menu-item (click)="onPin()">
      <mat-icon>push_pin</mat-icon>
      <span>Pin User</span>
    </button>
    <button mat-menu-item (click)="onMicMute()">
      <mat-icon>mic_off</mat-icon>
      <span>Mute User</span>
    </button>
    <button mat-menu-item (click)="onCamOff()">
      <mat-icon>videocam_off</mat-icon>
      <span>Camera Off</span>
    </button>
  </mat-menu>